// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 254 ? "56c12eb5" : chunkId) + "." + {"0":"c16901409cfda698","34":"1f0532d954a53573","62":"d6d34c00a66c77bd","254":"76884470e675699a","437":"35ec10deeab542dd","895":"328d8152dd09c860"}[chunkId] + ".js";
};